import React from 'react'

const Link = ({ href, onClick, current, className, ...props }) =>
  <a {...props} href={href}
    className={[ className, current == href ? 'active' : '' ]
      .filter(Boolean).join(' ')}
    onClick={e => {
      e.preventDefault()
      onClick(href)
    }}
  />

export default Link
